import Keycloak from "keycloak-js";

const data = window.location.href;
const urls = String(data);

const getGroupName = (url) => {
  let f = url.split("/");
  let dats;

  for (let i = 2; i < f.length; i++) {
    if (f[i] === "driverportal") {
      dats = f[i + 1]
    }
  }
  return dats;
};

const keycloak = new Keycloak(
  {
    realm: getGroupName(urls),
    url: `${process.env.REACT_APP_PROXY_HOST}/auth`,
    clientId: getGroupName(urls)
  }
)

export default keycloak;